// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/flat-light.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/flat-light/flat-light.js';

mount([g0]);
